import styled, { css } from 'styled-components';
import { Flexbox, Theme, baseContainer, baseStyling, focusRing } from '@redsift/design-system';
import { StyledChartContainerProps } from './types';

/** Component style. */
export const StyledChartContainer = styled.div<StyledChartContainerProps>`
  ${baseStyling}

  .redsift-chart-container__content {
    display: flex;
    align-items: center;
    gap: 16px;
    font-family: var(--redsift-typography-font-family-poppins);
    font-size: 11px;
    justify-content: center;
    position: relative;

    ${baseContainer}

    ${focusRing}
  }

  svg {
    display: block;
    user-select: none;
  }

  text {
    ${({ $theme }) => css`
      fill: var(--redsift-color-neutral-${$theme === Theme.dark ? 'white' : 'x-dark-grey'});
    `}
  }

  table {
    border-collapse: collapse;
    border: 1px solid #ebebeb;
    margin: 10px auto;
    text-align: center;
    width: 100%;
    max-width: 500px;

    td, th, caption {
        padding: 0.5em;
    }

    caption {
      padding: 1em 0;
      font-size: 1.2em;
      color: #555;
    }

    thead tr, tr:nth-child(even) {
      background: #f8f8f8;
    }

    th {
      font-weight: 600; 
    }
`;

export const StyledChartContainerTitle = styled(Flexbox)<StyledChartContainerProps>``;

export const StyledChartContainerCaption = styled.p<Omit<StyledChartContainerProps, 'onReset'>>`
  font-family: var(--redsift-typography-caption-font-family);
  font-size: var(--redsift-typography-caption-font-size);
  font-weight: var(--redsift-typography-caption-font-weight);
  line-height: var(--redsift-typography-caption-line-height);
  margin: 8px 0;
`;
